import { CARD_DETAIL_SUPP_MODAL } from 'src/services/types';

/*
US3439584: this module was created because we need to remove the old card-detail
modules completely, as part of the code-cleanup effort.
*/
export function suppModalState(isOpen, suppModalDtmData) {
  return {
    type: CARD_DETAIL_SUPP_MODAL,
    data: { suppModalOpen: isOpen, suppModalDtmData }
  };
}
